import { render, staticRenderFns } from "./MisurazioniList.vue?vue&type=template&id=417bea9c"
import script from "./MisurazioniList.vue?vue&type=script&lang=js"
export * from "./MisurazioniList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports